<template>
  <div>
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <p class="text-c f-s-8 agTitle">签署协议</p>
          <van-row class="f-s-6 agInfo">
            <p>
              {{ textOne }}
            </p>
            <input
              class="inputStyle m-t-04"
              :placeholder="'请输入您的' + item.agreementsign"
              v-for="(item, i) in signInfoList"
              :key="i"
              v-model="item.info"
            />
            <van-button color="#ff9c57" block class="m-t-04" @click="subInfo">确定</van-button>
            <van-button type="default" block class="m-t-04" @click="back">返回</van-button>
          </van-row>
          <van-row class="f-s-6 agFoot">
            <p>重要提醒:</p>
            <p>
              a.用户报名小筑《{{
                agreementName
              }}》必须签署协议,否则不能享受后续服务;
            </p>
            <p>
              b.用户在《{{
                agreementName
              }}》协议中所填写信息必须真实,且与用户的注册信息一致
            </p>
          </van-row>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  props: {
    agreementName: {
      type: String,
    },
    cid:{
      type:String
    }
  },
  data() {
    return {
      show: false,
      textOne:
        "我们非常重视您的隐私和个人信息保护,本协议签名仅限用于课程协议用途,不会泄露您的信息",
      signInfoList: [],
    };
  },
  methods:{
    subInfo(){
      for(const key in this.signInfoList) {
        if(this.signInfoList[key].info == "") {
          this.$toast('请填写' + this.signInfoList[key].agreementsign + '信息');
          return false
        }
      }
      let data = {
        uid : this.uid(),
        cid : this.cid,
        userSignAgreementInfos : this.signInfoList
      }
      this.ApiNew.Mine.updUserSignAgreementInfo(data).then(res => {
        if(res.retuCode == 5000) {
          this.$router.push({
            path: "/chapter",
            query: {
              cid: this.cid,
            },
          });
        } else {
          this.$toast(res.message)
        }
      })
    },
    back(){
      this.show = false
      this.$parent.show = true
    }
  }
};
</script>

<style scoped>
.inputStyle {
  border: 1px solid #cccccc;
  padding-left: 10px;
  background: #f4f7fa;
}
.van-overlay {
  z-index: 2002;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  border-radius: 5px;
  width: 276px;
  background-color: #fff;
}
.agTitle {
  padding-top: 18px;
  padding-bottom: 19px;
  background: #f4f7fa;
  border-radius: 5px;
}
.agInfo {
  padding-left: 26px;
  padding-right: 21px;
  padding-top: 21px;
  padding-bottom: 27px;
}
.agFoot {
  padding-top: 5px;
  padding-bottom: 20px;
  padding-left: 24px;
  color: #73787f;
  padding-right: 24px;
}
</style>